import { nnSlideDown, nnSlideUp } from './helpers.js';

export function accordion() {
    const $accordionSummaries = document.querySelectorAll('.accordion summary');

    $accordionSummaries?.forEach($el => {
        $el.addEventListener('click', accordClick);
    });
}

function accordClick(e) {
    e.preventDefault();
    console.log('accord', e.target);
    const $thisAccordion = e.target.closest('.accordion');
    const $thisContent = $thisAccordion.querySelector('.accordion__content');
    const animDuration = ($thisAccordion.dataset.duration) ? $thisAccordion.dataset.duration : 400;

    if ( !$thisAccordion.hasAttribute('open') ) {
        $thisAccordion.setAttribute('open', '');
        $thisAccordion.classList.add('active');
        nnSlideDown($thisContent, animDuration);
    } else {
        nnSlideUp($thisContent, animDuration);
        $thisAccordion.classList.remove('active');
        setTimeout(function() {
            $thisAccordion.removeAttribute('open');
        }, 510);
    }
}